<template>
  <e-tooltip>
    <template #activator>
      <e-icon name="doubleCheck" class="mr-2 text-green" />
    </template>

    <div class="text-secondary">Контент уже опубликован</div>
  </e-tooltip>
</template>

<script setup lang="ts">
import { EIcon, ETooltip } from '@/core/components/ui';
</script>
